import React, { ReactNode } from 'react';

export const TextDefaultChecker = () => true;

interface Props {
  children: ReactNode[] | ReactNode;
  t: string;
  cs: string;
  bf: string;
  f: string;
  mf: string;
  b: string;
}

export default function TextDefault(props: Props) {
  const { t, cs, bf, f, mf, b, children } = props;

  const style: { [key: string]: string | number } = {};

  if (t === '1') style.color = '#1C4781';
  if (cs) style.color = cs;
  if (b === '1') style.fontWeight = 'bold';
  if (f || mf || bf) style.fontSize = Number(mf || f || bf);

  return <span style={style}>{children}</span>;
}
